import { connect } from "react-redux";
import Header from "../Components/header";
import { Setcurrentinfo, removeuser, setuser } from "../Service/Actions/action";

const dispatchpart = (dispatch) => ({
  Setinfo_ofuser: (data) => dispatch(Setcurrentinfo(data)),
  RemoveUser: () => dispatch(removeuser()),
  SetUser: (data) => dispatch(setuser(data)),
});

const getpart = (state) => ({
  state,
});

export default connect(getpart, dispatchpart)(Header);
